<p-dialog [(visible)]="visible" [modal]="true" [style]="{width:'700px'}" [header]="titulo">
  <div class="p-4 max-h-[70vh] overflow-y-auto text-sm leading-relaxed">
    <ng-container *ngIf="tipo === 'aviso-legal'">
      <h3 class="text-lg font-medium mb-2">Aviso legal</h3>
      <p>Este es un texto mock para el aviso legal. Aquí irían las menciones obligatorias según la LSSI-CE.</p>
    </ng-container>

    <ng-container *ngIf="tipo === 'privacidad'">
      <h3 class="text-lg font-medium mb-2">Política de privacidad</h3>
      <p>Este es un texto mock para la política de privacidad. Aquí explicarías cómo recoges, usas y proteges los datos.</p>
    </ng-container>

    <ng-container *ngIf="tipo === 'cookies'">
      <h3 class="text-lg font-medium mb-2">Política de cookies</h3>
      <p>Este es un texto mock para la política de cookies. Aquí detallarías el uso de cookies y tecnologías similares.</p>
    </ng-container>

    <ng-container *ngIf="tipo === 'condiciones'">
      <h3 class="text-lg font-medium mb-2">Condiciones de uso</h3>
      <p>Este es un texto mock para las condiciones de uso. Aquí establecerías los términos del servicio.</p>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cerrar" (click)="cerrar()"/>
  </ng-template>
</p-dialog>
